<template>
  <div class="page-container">
    <AppNavbar>
        <a href="#" @click.prevent="$router.back()">Go back</a>
    </AppNavbar>
    <div class="spacer"></div>
    <div class="content-wrapper">
      <div class="plans-page">
                <h1 class="plans-heading">{{  'Choose your plan' }}</h1>
        <p v-if="fromSignIn" class="sign-in-info">You're not registered yet.</p>
        <div class="pricing-plans-wrapper">
          <PricingPlans :address="address" />
        </div>
      </div>
    </div>
    <AppFooter />
  </div>

</template>

<script>
import { defineComponent } from "vue";
import PricingPlans from "@/components/PricingPlans.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppNavbar from "@/components/AppNavbar.vue";

export default defineComponent({
  name: "PlansPage",
  components: {
    PricingPlans,
    AppFooter,
    AppNavbar
  },
  
  data() {
    return {
      fullName: "",
      fromSignIn: false,
      address: null
    };
  },
  
  mounted() {
    // Check if user came from sign-in
    this.fromSignIn = this.$route.query.fromSignIn === 'true';
    this.address = this.$route.query.address;
  },
  

  
  methods: {


    async handleGoBackClick() {
      this.$router.push('/');
    }
  }
});
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  flex: 1 0 auto;
}

.plans-page {
  padding: 2rem;
  min-height: auto;
  background-color: #f7f7f7;
}

.plans-heading {
  font-size: 48px;
  font-weight: 300;
  text-align: center;
  color: #333;
}

.sign-in-info {
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  color: #666;
  font-style: italic;
}

.pricing-plans-wrapper {
  margin-top: 2rem;
}


.spacer {
  height: 80px;
}

.go-back-btn:hover {
  color: var(--primary-color);
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .spacer {
    height: 0;
  }
  
  .plans-page {
    padding: 1rem;
  }
  
  .plans-heading {
    font-size: 32px;
    margin-bottom: 1rem;
  }
  
  .sign-in-info {
    font-size: 16px;
    margin-bottom: 1rem;
  }
  
  .pricing-plans-wrapper {
    margin-top: 1rem;
  }
}

@media (max-width: 480px) {
  .plans-page {
    padding: 0.5rem;
  }
  
  .plans-heading {
    font-size: 28px;
  }
}
</style> 